module.exports = __webpack_public_path__ + "static/littlecosypenguin-3000238ffcdc438e0d4ec9180c881733.jpeg";